/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

(function ($) {

    $(document).ready(function () {
        
        const links = document.querySelectorAll( '.hemis-blocks-video-popup a' );
        if ( links.length > 0 && 'undefined' !== typeof lightGallery ) {
            for ( let i = 0; i < links.length; i++ ) {
                lightGallery( links[ i ], {
                    selector: 'this',
                    download: false,
                    autoplayFirstVideo: false,
                    autoplayVideoOnSlide: false,
                    plugins: [lgVideo]
                } );
            }
        }

    });

})(jQuery);